import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  font-size: 0.75rem;
`;

const Text = styled.div`
  color: black;
  padding: 0.15rem;
  margin-left: 1rem;
`;

const TitleText = styled.div`
  font-size: 1rem;
  font-weight: 700;
`;

const ReleaseMenuItem = ({ release }) => (
  <Container>
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <TitleText>{release.title.length ? release.title : '[untitled]'}</TitleText>
      <div>{release.display_artist_name}</div>
    </div>
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Text>{release.asset_release_upc}</Text>
      <Text style={{ backgroundColor: 'lightgray' }}>{release.type}</Text>
    </div>
  </Container>
);

export default ReleaseMenuItem;
